import { useTranslation } from 'react-i18next'

import type { CampaignWaitingBand } from '#/entities/campaign'
import { Button } from '#/shared/ui/button'

interface CampaignWaitingBandProps {
  band: CampaignWaitingBand
  /** The Contact tab on everyone the band counts. The Phone panel holds one
   *  thread at a time, so the band opens the list rather than one of them. */
  onOpenList: () => void
}

/**
 * The one thing on this page a person can act on right now. It sits above the
 * analytics on purpose — unanswered replies are work, the rest is reading.
 */
export function CampaignWaitingBandCard({
  band,
  onOpenList,
}: CampaignWaitingBandProps) {
  const { t } = useTranslation()
  return (
    <section className="flex flex-wrap items-center gap-4 rounded-xl border border-gray-200 bg-white p-4">
      <span
        aria-hidden="true"
        className="size-2 shrink-0 rounded-full bg-campaign-attention"
      />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="text-2xs font-medium tracking-wider text-warm-500">
          {t('campaigns.detail.waiting.label')}
        </p>
        <button
          type="button"
          onClick={onOpenList}
          className="cursor-pointer text-left text-base font-semibold text-announce-ink hover:underline"
        >
          {band.headline}
        </button>
        <p className="text-xs text-warm-500">{band.oldest}</p>
      </div>
      <div className="hidden h-px flex-1 lg:block" />
      <p className="max-w-58 text-xs text-warm-500">{band.explainer}</p>
      <Button size="sm" pressEffect onClick={onOpenList}>
        {t('campaigns.detail.actions.reviewReplies')}
      </Button>
    </section>
  )
}
